export default class Effects {
  constructor (context) {
    this.context = context;
  }

  gain () {
    const gain = this.context.createGain();
    return gain;
  }

  filter () {
    const filter = this.context.createBiquadFilter();
    return filter;
  }

  verb (length = 1) {
    const verb = this.context.createConvolver();
    const samples = this.context.sampleRate * length;

    const impulse = this.context.createBuffer(2, samples, this.context.sampleRate);
    const impulseL = impulse.getChannelData(0);
    const impulseR = impulse.getChannelData(1);

    for (let i = 0; i < samples; i++) {
      impulseL[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / samples, 1);
      impulseR[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / samples, 1);
    }

    verb.buffer = impulse;

    return verb;
  }

  delay (time = 0.1, intensity = 0.01) {
    const delay = this.context.createDelay();
    delay.delayTime.setValueAtTime(time, this.context.currentTime);
    const feedback = this.gain();
    feedback.gain.value = intensity;

    delay.connect(feedback);
    feedback.connect(delay);

    return delay;
  }
}
